import React, {ReactNode} from 'react';
import {View} from 'react-native';
type Props = {
  children: ReactNode | ReactNode[];
  testID?: string;
};

export function Container({children, testID}: Props) {
  return (
    <View testID={testID} style={{flexGrow: 1, flex: 1}}>
      {children}
    </View>
  );
}
